import React, { useEffect, useState } from "react";
import MainPageComponent from "./main.page";
import { useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { GENERATE_SN, ROOT } from "modules/serial-number";
import {
  openCreationDialog,
  openImportDialog,
  openUnassignDialog,
} from "modules/serial-number/redux";
import {AccessRights} from "lib/constants/accessRights";
import LoadingComponent from "components/loading";
import { getLang } from "app/feature/constants";
import qs from "query-string";
import {canAccess} from "../../../profile/redux/selector/profile.selector";

function MainPageContainer() {
  const history = useHistory();
  const dispatch = useDispatch();
  const [activeIndex, setActiveIndex] = useState(0);
  const location = useLocation();

  const hasSerialNumberViewAccessRight = useSelector((state) =>
    canAccess(state, AccessRights.Qr.SERIAL_NUMBER_READ));
  const hasSerialNumberBatchAccessRight = useSelector((state) =>
    canAccess(state, AccessRights.Qr.BATCH_READ));
  const hasSerialNumberAssignAccessRight = useSelector((state) =>
    canAccess(state, AccessRights.Qr.ASSIGN));
  const hasSerialNumberUnassignAccessRight = useSelector((state) =>
    canAccess(state, AccessRights.Qr.UNASSIGN_READ));
  const hasSerialNumberPatternViewAccessRight = useSelector((state) =>
    canAccess(state, AccessRights.Qr.TAG_READ));
  const hasAdtInfoViewAccessRight = useSelector((state) =>
    canAccess(state, AccessRights.Qr.ADDITIONAL_INFO_READ));
  const hasSerialNumberGenerateAccessRight = useSelector((state) =>
    canAccess(state, AccessRights.Qr.SERIAL_NUMBER_CREATE));
  const hasSerialNumberUnassignSnAccessRight = useSelector((state) =>
    canAccess(state, AccessRights.Qr.UNASSIGN_WRITE));
  const hasAdtInfoAddAccessRight = useSelector((state) =>
    canAccess(state, AccessRights.Qr.ADDITIONAL_INFO_CREATE));
  const hasTagAddAccessRight = useSelector((state) =>
    canAccess(state, AccessRights.Qr.TAG_WRITE));
  const lang = useSelector((state) => state.constant.languages);

  const qsParams = qs.parse(location.search);
  const currentSearch = qsParams.tab || "";

  useEffect(() => {
    if (
      !(hasSerialNumberViewAccessRight || hasSerialNumberPatternViewAccessRight)
    ) {
      history.push("/admin/dashboard");
    }
  }, [
    history,
    hasSerialNumberViewAccessRight,
    hasSerialNumberPatternViewAccessRight,
  ]);

  useEffect(() => {
    let tempIndex = 0;
    switch (currentSearch) {
      case "sn":
        tempIndex = 0;
        break;
      case "batch":
        tempIndex = 1;
        break;
      case "pattern":
        tempIndex = 2;
        break;
      case "assign":
        tempIndex = 3;
        break;
      case "unassign":
        tempIndex = 4;
        break;
      case "adt-info":
        tempIndex = 5;
        break;
      default:
        tempIndex = 0;
    }
    setActiveIndex(tempIndex);
  }, [currentSearch]);

  if (
    !(hasSerialNumberViewAccessRight || hasSerialNumberPatternViewAccessRight)
  )
    return <LoadingComponent />;

  let tabLabels = [];
  tabLabels.push({ label: getLang(lang, "label.SERIAL_NUMBER_LIST"), access: hasSerialNumberViewAccessRight});
  tabLabels.push({ label: getLang(lang, "label.SERIAL_NUMBER_BATCH"), access: hasSerialNumberBatchAccessRight});
  tabLabels.push({ label: getLang(lang, "label.SAVED_PATTERN"), access: hasSerialNumberPatternViewAccessRight});
  tabLabels.push({ label: getLang(lang, "label.ASSIGN"), access: hasSerialNumberAssignAccessRight});
  tabLabels.push({ label: getLang(lang, "label.UNASSIGN"), access: hasSerialNumberUnassignAccessRight});
  tabLabels.push({ label: getLang(lang, "label.ADDITIONAL_INFO"), access: hasAdtInfoViewAccessRight});

  const handleChange = (event, index) => {
    setActiveIndex(index);
    history.replace({
      pathname: ROOT,
      search: `?tab=${
        index === 1
          ? "batch"
          : index === 2
          ? "pattern"
          : index === 3
          ? "assign"
          : index === 4
          ? "unassign"
          : index === 5
          ? "adt-info"
          : "sn"
      }`,
    });
  };

  function handleGoToGenerate() {
    if (hasSerialNumberGenerateAccessRight) {
      history.push(GENERATE_SN);
    }
  }

  const handleAddPattern = () => {
    dispatch(openCreationDialog());
  };

  const handleAddAdtInfo = () => {
    dispatch(openImportDialog());
  };

  const handleUnassign = () => {
    dispatch(openUnassignDialog());
  };

  return (
    <>
      <MainPageComponent
        hasSerialNumberGenerateAccessRight={hasSerialNumberGenerateAccessRight}
        handleChange={handleChange}
        activeIndex={activeIndex}
        tabLabels={tabLabels}
        handleGoToGenerate={handleGoToGenerate}
        handleAddPattern={handleAddPattern}
        lang={lang}
        handleAddAdtInfo={handleAddAdtInfo}
        hasAdtInfoAddAccessRight={hasAdtInfoAddAccessRight}
        hasSerialNumberAssignAccessRight={hasSerialNumberAssignAccessRight}
        hasSerialNumberUnassignAccessRight={hasSerialNumberUnassignAccessRight}
        hasSerialNumberUnassignSnAccessRight={hasSerialNumberUnassignSnAccessRight}
        hasTagAddAccessRight={hasTagAddAccessRight}
        handleUnassign={handleUnassign}
      />
    </>
  );
}

export default MainPageContainer;
